module.exports = __webpack_public_path__ + "media/images/themes/mandy/7-fc2ecb19be8be5a6668a05a332838758.webp";